import { render, staticRenderFns } from "./customerInformationUpdate.vue?vue&type=template&id=6133ca92&scoped=true&"
import script from "./customerInformationUpdate.vue?vue&type=script&lang=js&"
export * from "./customerInformationUpdate.vue?vue&type=script&lang=js&"
import style0 from "./customerInformationUpdate.vue?vue&type=style&index=0&id=6133ca92&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133ca92",
  null
  
)

export default component.exports